<template>
    <div class="container mb-5">

        <div class="k-tabs">
            <ul class="k-tabs__list">
                <li @click="tabChanged('myDiscussions')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'myDiscussions'}]"><a href="javascript:;" class="k-tabs__link">Moje příspěvky ({{ myDiscussionsCount }})</a></li>
                <li @click="tabChanged('watchingDiscussions')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'watchingDiscussions'}]"><a href="javascript:;" class="k-tabs__link ">Sledované příspěvky ({{ watchingDiscussionsCount }})</a></li>
            </ul>

            <div class="k-tabs__actions">
                <a :href="DiscussionListLink" class="k-tabs__actions-link">
                    Diskusní fórum
                    <svg class="k-tabs__actions-icon k-tabs__actions-icon--after" role="img" width="15" height="15">
                        <use fill="currentColor" xlink:href="/images/spritesheet.svg#arrow-right"/>
                    </svg>
                </a>
            </div>
        </div>

        <transition-group name="list-complete" tag="div" class="k-table">
            <div v-for="discussion in discussions.data" :key="discussion.id" class="k-table__row">
                <div class="k-table__cell">
                    <div class="k-table__cell-image">
                        <img :src="discussion.user.prev_url" alt="" height="67px">
                    </div>

                    <div class="mr-auto">
                        <a :href="discussion.url">
                            <strong class="k-strong d-block mb-2">{{ discussion.title }}</strong>
                        </a>
                        <div class="k-table__cell-meta ml-0">Vytvořený dne {{ discussion.created_at }}</div>
                    </div>
</div>
                    <div class="k-table__cell k-table__cell--info">
                        <div class="k-table__cell-meta mx-0">
                            <strong class="k-strong d-block mb-2">{{ discussion.responses_count }}</strong>
                            <div class="">odpovědí</div>
                        </div>
                    </div>

                    <div class="k-table__cell k-table__cell--info">
                        <div class="k-table__cell-meta mx-0">
                            <strong class="k-strong d-block mb-2">{{ discussion.views_count }}</strong>
                            <div class="">zobrazení</div>
                        </div>
                    </div>

                    <div class="k-table__cell k-table__cell--last-post text-left">
                        <div class="k-table__cell-meta mx-0">
                            {{ discussion.latest_response_date }} od <a :href="discussion.latest_response_user.detail_url"><strong class="k-strong">{{ discussion.latest_response_user.name }}</strong></a>
                            <div class="mt-2">poslední příspěvek</div>
                        </div>
                    </div>


            </div>
            <div key="0" v-if="discussions.data && discussions.data.length === 0" class="k-table__cell p-3">
                Nebyly nalezeny žádné příspěvky.
            </div>
        </transition-group>

        <pagination class="mt-5" :data="discussions" @pagination-change-page="getData" :limit="2"></pagination>

    </div>
</template>

<script>
    import Pagination from 'laravel-vue-pagination';

    export default {
        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            },
            myDiscussionsCount: {
                type: Number,
                default: 0
            },
            watchingDiscussionsCount: {
                type: Number,
                default: 0
            }
        },

        data: () => ({
            discussions: {},
            activeTab: 'myDiscussions'
        }),

        computed: {
            /**
             * Get discussion list link
             *
             * @return string
             */
            DiscussionListLink: function() {
                return Links.discussionList;
            }
        },

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            filter: this.activeTab
                        }
                    });
                    if (result.status === 200 && result.data) {
                        this.discussions = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Tab changed
             *
             * @returns void
             */
            tabChanged: function(value) {
                if (this.activeTab !== value) {
                    this.activeTab = value;
                    // get data and keep current page
                    this.getData();
                }
            }
        },

        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>
    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity .5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }
</style>
